import type { FontFamily } from '../types/font.ts'

export const fontFamilyMap: Record<FontFamily, string> = {
  heading: 'font-heading',
  sans: 'font-sans',
}
